import Svg, { Path } from 'react-native-svg'

export const RupeeIconFilled = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4 8a1 1 0 0 1 0 2h-1.14a4 4 0 0 1-2.61 2.78l2.26 1.36a1 1 0 0 1-1.02 1.72l-5-3s-.06-.06-.09-.08a.67.67 0 0 1-.15-.14l-.11-.15a1 1 0 0 1-.08-.18 1.18 1.18 0 0 1 0-.2L8 14v-.07a1.29 1.29 0 0 1 0-.19c.017-.065.04-.129.07-.19v-.06c0-.06.06-.06.08-.09a.91.91 0 0 1 .3-.26l.16-.08h.21L9 13h2a2 2 0 0 0 1.72-1H8a1 1 0 0 1 0-2h4.72A2 2 0 0 0 11 9H8a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2h-1.56c.187.312.328.649.42 1H16Z"
      />
    </Svg>
  )
}
